import { render, staticRenderFns } from "./CancelOrderFlowInfo.vue?vue&type=template&id=8253950e&scoped=true&"
import script from "./CancelOrderFlowInfo.vue?vue&type=script&lang=js&"
export * from "./CancelOrderFlowInfo.vue?vue&type=script&lang=js&"
import style0 from "./CancelOrderFlowInfo.vue?vue&type=style&index=0&id=8253950e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8253950e",
  null
  
)

export default component.exports